'use client'

import clsx from 'clsx'
import React from 'react'

interface TabButtonProps {
	variant?: 'full' | 'button'
	isActive: boolean
	onClick: () => void
	children: React.ReactNode
}

export const TabButton = (props: TabButtonProps) => {
	return (
		<button
			onClick={props.onClick}
			className={clsx('text-msc-blue border-b-3 pb-2', {
				'flex-1 text-center': props.variant === 'full',
				'rounded px-4 py-2': props.variant === 'button',
				'bg-msc-blue text-white': props.variant === 'button' && props.isActive,
				'border-msc-blue': props.isActive,
				'border-transparent hover:text-gray-600 hover:border-gray-300': !props.isActive,
			})}
		>
			<div
				className={clsx('flex items-center gap-2 whitespace-nowrap', {
					'justify-center text-sm font-semibold': props.variant === 'full',
				})}
			>
				{props.children}
			</div>
		</button>
	)
}
